import scrollToTarget from './scrollToTarget';

/* =========================================================
 * プラン表示タブ
========================================================= */
function activateNonProfitTab() {
  document.querySelector('.nonProfitTab').classList.add('activeTab');
  document.querySelector('.profitTab').classList.remove('activeTab');

  document.querySelectorAll('.jsNonProfitPrice').forEach((element) => {
    element.classList.remove('hidden');
  });
  document.querySelectorAll('.jsProfitPrice').forEach((element) => {
    element.classList.add('hidden');
  });
}

function activateProfitTab() {
  document.querySelector('.profitTab').classList.add('activeTab');
  document.querySelector('.nonProfitTab').classList.remove('activeTab');

  document.querySelectorAll('.jsProfitPrice').forEach((element) => {
    element.classList.remove('hidden');
  });
  document.querySelectorAll('.jsNonProfitPrice').forEach((element) => {
    element.classList.add('hidden');
  });
}

function scrollToPlanDescription() {
  scrollToTarget('.jsScrollToPlan', '#planDesc');
}

function scrollToPaymentForm() {
  scrollToTarget('.jsScrollToForm', '#jsPaymentForm');
}

export default function initializePlanCards() {
  document.getElementById('jsNonProfitTabBtn').addEventListener('click', activateNonProfitTab);
  document.getElementById('jsProfitTabBtn').addEventListener('click', activateProfitTab);
  document.querySelectorAll('.jsScrollToPlan').forEach((element) => {
    element.addEventListener('click', scrollToPlanDescription);
  });
  document.querySelectorAll('.jsScrollToForm').forEach((element) => {
    element.addEventListener('click', scrollToPaymentForm);
  });
}
